var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row justify-center align-center small-font w-100"},[_c('v-sheet',{staticClass:"ma-0 pa-2 w-100",attrs:{"color":"white","elevation":"3","rounded":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('call-log-table')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }